import { Component, OnInit } from '@angular/core';
import { NoticiasModel } from './noticias.model'
import { DadosAcessoService } from '../../../dadosAcesso.service'
import { AcessoApiService } from '../../../acessoApi.service'

@Component({
  selector: 'app-mensagens-importantes',
  templateUrl: './mensagens-importantes.component.html',
  styleUrls: ['./mensagens-importantes.component.css']
})

export class MensagensImportantesComponent implements OnInit {

  public mostrarEditar: boolean

  public noticias: any

  constructor(private dadosAcesso: DadosAcessoService, private acessoAPI:AcessoApiService) {

    if(sessionStorage.getItem('ExibirBotaoEditar') === 'true'){
      this.mostrarEditar = true
    }
    else{
      this.mostrarEditar = false
    }


   acessoAPI.getMensagensImportantes().subscribe(res =>{
     
     this.noticias = res
   });
 

   }
   editarMensagem(id_not: any): any{
    this.dadosAcesso.setIDNOT(id_not)

   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/home/mensagens-importantes/mensagens-importantes.component.ts